export default "/assets/images/mila-feed-03.mp4?53af05047c61740739b3de5d477e9bb4";